function state() {
  return {
    buttonActive: "",
    showDescFooter: false,
    footerTemplate: {},
    headerIconLeft: {},
    headerIconRight: {},
    searchBar: "",
    searchBarPlaceholder: "Search",
    searchBarTriggered: false,
    searchBarCondition: false, // open or close
    mobileBodyHeight: {},
    backLink: null,
  };
}

export default state;
